import { render, staticRenderFns } from "./ScenarioDett.vue?vue&type=template&id=8d421b48&"
import script from "./ScenarioDett.vue?vue&type=script&lang=js&"
export * from "./ScenarioDett.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports